import State from '../core/State';
import initialState from '../initialState';
import { ProjectTypeForListFragment } from './../generated/graphql';

export const startFetchingProjectTypes = () => (state: State): State => ({
  ...state,
  projectTypes: {
    ...state.projectTypes,
    projectTypesFetching: state.projectTypes.projectTypesFetching + 1,
  },
});

export const finishFetchingProjectTypes = () => (state: State): State => ({
  ...state,
  projectTypes: {
    ...state.projectTypes,
    projectTypesFetching: state.projectTypes.projectTypesFetching - 1,
  },
});

export const setProjectTypes = (projectTypes: Array<ProjectTypeForListFragment>) => (state: State): State => ({
  ...state,
  projectTypes: {
    ...state.projectTypes,
    projectTypes,
  },
});

export const dispose = () => (state: State): State => ({
  ...state,
  projectTypes: {
    ...initialState.projectTypes,
    projectTypesFetching: state.projectTypes.projectTypesFetching,
  },
});
